import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { facePersonType } from './facePersonType';
import { newFace } from './newFace';

export const inputActions = [facePersonType, newFace];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
